import { render, staticRenderFns } from "./Beauticians.vue?vue&type=template&id=1aa48de0&lang=pug&"
import script from "./Beauticians.vue?vue&type=script&lang=ts&"
export * from "./Beauticians.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports